var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-attendance-modal-component" }, [
    _c("div", { staticClass: "room-attendance-modal" }, [
      _c(
        "div",
        { staticClass: "room-attendance-header" },
        [
          _c("div", { staticClass: "flex items-center gap-x-2" }, [
            _c("div", { staticClass: "room-attendance-title" }, [
              _vm._v(_vm._s(_vm.$t("attendance.modal.title")) + " "),
            ]),
            _c("div", { staticClass: "room-attendance-note text-sm" }, [
              _vm._v(_vm._s(_vm.$t("attendance.modal.note")) + " "),
            ]),
          ]),
          _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "room-attendance-body" },
        [
          _c("RoomAttendanceTable", {
            attrs: { attendanceList: _vm.attendanceListProp },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "room-attendance-footer" },
        [
          _c("GrmBtn", { on: { click: _vm.handleClickDownloadFile } }, [
            _vm._v(_vm._s(_vm.$t("attendance.modal.exel.title"))),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "room-attendance-mobile-modal" }, [
      _c("div", { staticClass: "room-attendance-mobile-header" }, [
        _c("button", {
          staticClass: "room-attendance-mobile-btn back",
          on: { click: _vm.onClose },
        }),
        _c("div", { staticClass: "room-attendance-mobile-title" }, [
          _vm._v(_vm._s(_vm.$t("attendance.modal.title"))),
        ]),
        _c("button", {
          staticClass: "room-attendance-mobile-btn excel",
          on: { click: _vm.handleClickDownloadFile },
        }),
      ]),
      _c("div", { staticClass: "room-attendance-note text-sm" }, [
        _vm._v(_vm._s(_vm.$t("attendance.modal.note"))),
      ]),
      _c(
        "div",
        { staticClass: "room-attendance-mobile-body" },
        [
          _c("RoomAttendanceMobileList", {
            attrs: { attendanceList: _vm.attendanceListProp },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }